import {
  AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, ViewChild
} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgApplicationTab, IExgTab} from 'exc-tab-v2';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgDataListComponent, ExgModalService} from 'exc-controls-v2';
import {ExgTabV2Component, ExgTabV2ComponentHeaderElement} from '../misc/exg-tab-v2/exg-tab-v2.component';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {of} from 'rxjs';
import {ReceiptDetailsComponent} from './drawer/receipt-details.component';
import {EnumerationService} from '../services/enumeration.service';
import {AnnotationTextComponent} from './annotation/annotation-text.component';
import {AnnotationCorrectionComponent} from './annotation/annotation-correction.component';
import {ApplicationService} from '../services/application.service';
import {ViewerComponent} from '../reference/viewer.component';
import {ReceiptReviewComponent} from './drawer/receipt-review.component';
import {IExgEvent} from '../misc/interfaces/IExgEvent';
import {ExgApplicationEventEmitter} from '../misc/classes/ExgApplicationEventEmitter';
import {UserSettingsService} from '../services/user-settings.service';
import {ExcPdfviewerv3Component} from '../misc/exc-pdf-viewer-v3/exc-pdfviewerv3.component';

@Component({
  selector: 'app-receipt-checkview',
  templateUrl: './receipt-checkview.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceiptCheckviewComponent
  extends ExcTranslation
  implements OnInit, AfterViewInit, IExgTab, IExgEvent, OnDestroy {

  [key: string]: any;

  Events = new ExgApplicationEventEmitter();
  /************************/
  @Input()
  Data: { rcptID: string; reloadOpenerView: any, checkRestore: boolean } = {
    rcptID: '',
    reloadOpenerView: () => {
    },
    checkRestore: false
  };
  @Input()
  set inputTabinstance(value: any) {
    this.tabinstance = value;
  }
  tabinstance: any;
  /************************/
  @ViewChild(ReceiptDetailsComponent) VCreceipt!: ReceiptDetailsComponent;
  @ViewChild(ReceiptReviewComponent) VCreceiptReview!: ReceiptReviewComponent;
  @ViewChild('VCTextAnnotation', {read: AnnotationTextComponent})
  VCNote!: AnnotationTextComponent;
  @ViewChild('VCCorrectionAnnotation', {read: AnnotationCorrectionComponent})
  VCCorrection!: AnnotationCorrectionComponent;
  //
  @ViewChild(ExcPdfviewerv3Component) VCPdfViewer!: ExcPdfviewerv3Component;
  @ViewChild('VCreceiptCorrectionTable', {read: ExgDataListComponent})
  VCreceiptCorrectionTable!: ExgDataListComponent;
  @ViewChild('VCreceiptNoteTable', {read: ExgDataListComponent})
  VCreceiptNoteTable!: ExgDataListComponent;
  @ViewChild('VCrightTabControl', {read: ExgTabV2Component})
  VCrightTabControl!: ExgTabV2Component;
  @ViewChild('DivDrawer', {read: ElementRef}) DivDrawer!: ElementRef;

  viewerurl = '';
  /************************/
  init = true;
  checkChanges = true;
  /************************/
  mode = 0; // 0 Inaktiv, 1 Trim, 2 Notes
  rightTabs: ExgTabV2ComponentHeaderElement[] = [];

  workspace = {
    hideViewer: false,
    receiptData: {} as any,
    duplicates: [] as any[],
    details: {} as any,
    company: {} as any,
    companyLinkData: [] as any[],
    commentaryDate: [] as any[],
    commentary: [] as any[],
    isLoading: true,
    isLoadingPreview: false,
    receiptReference: {
      receiptData: [] as any[],
      receiptPaging: {} as any,
      referenceData: [] as any[],
      referencePaging: {} as any,
    },
    annotationData: {} as any,
    aiResult: {} as any,
    aiQueue: {} as any,
    reviewPreCalc: {
      receiptNetto: 0.0,
      receiptVat: 0,
      receiptBrutto: 0.0,
      diffBrutto: 0.0,
      diffNetto: 0.0,
      diffVat: 0.0,
      originalBrutto: 0.0,
      originalNetto: 0.0,
      originalVat: 0.0,
      resultBrutto: 0.0,
      resultNetto: 0.0,
      resultVAT: 0.0,
      corrLength: 0,
      sumCorrNetto: 0.0,
      sumCorrVat: 0.0,
      sumCorrBrutto: 0.0,

      preCalc: () => {
        const preCalc = this.workspace.reviewPreCalc;
        preCalc.diffNetto = this.VCreceipt.calcDiffNetto(
          this.receiptCorrectionTable.getCorrSumme(1)
        );
        preCalc.diffBrutto = this.VCreceipt.calcDiffBrutto(
          this.receiptCorrectionTable.getCorrSumme(1)
        );
        preCalc.diffVat = this.VCreceipt.calcDiffVAT(
          this.receiptCorrectionTable.getCorrSumme(1)
        );

        preCalc.originalNetto = this.receiptCorrectionTable.originals;
        preCalc.originalBrutto = this.VCreceipt.calcDiffBrutto(
          this.receiptCorrectionTable.originals
        );
        preCalc.originalVat = this.VCreceipt.calcDiffVAT(
          this.receiptCorrectionTable.originals
        );

        preCalc.sumCorrNetto = this.receiptCorrectionTable.getCorrSumme(1);
        preCalc.sumCorrVat =
          this.workspace.receiptData?.rcptVATRate &&
          this.workspace.receiptData?.rcptVATRate > 0
            ? (this.receiptCorrectionTable.getCorrSumme(1) *
              this.workspace.receiptData?.rcptVATRate) /
            100
            : 0;
        preCalc.sumCorrBrutto =
          this.workspace.receiptData?.rcptVATRate &&
          this.workspace.receiptData?.rcptVATRate > 0
            ? this.receiptCorrectionTable.getCorrSumme(1) +
            (this.receiptCorrectionTable.getCorrSumme(1) *
              this.workspace.receiptData?.rcptVATRate) /
            100
            : this.receiptCorrectionTable.getCorrSumme(1);

        preCalc.resultNetto = preCalc.originalNetto - preCalc.sumCorrNetto;
        preCalc.resultBrutto = preCalc.originalBrutto - preCalc.sumCorrBrutto;
        preCalc.resultVAT = preCalc.originalVat - preCalc.sumCorrVat;

        preCalc.receiptVat = this.VCreceipt.calcVAT();

        preCalc.receiptBrutto = this.workspace.receiptData.rcptGrossSum;
        preCalc.receiptNetto = this.workspace.receiptData.rcptNetSum;
        preCalc.corrLength = this.receiptCorrectionTable.data.length;
      },
    },
    loadData: (
      incoming: any,
      company?: any,
      incomingDetails?: any,
      reference?: any,
      companyLink?: any,
    ) => {
      if (incoming) {
        this.workspace.receiptData = incoming;
        this.workspace.receiptData.rcptReviewReasons = this.workspace
          .receiptData.rcptReviewReasons
          ? JSON.parse(this.workspace.receiptData.rcptReviewReasons)
          : undefined;
        this.workspace.receiptData.rcptReviewHints = this.workspace
          .receiptData.rcptReviewHints
          ? JSON.parse(this.workspace.receiptData.rcptReviewHints)
          : undefined;
      }
      if (company) {
        this.workspace.loadCompanyData(company);
      }
      if (incomingDetails) {
        this.Details = incomingDetails;
        this.workspace.details = incomingDetails;
      }
      if (reference) {
        this.workspace.loadReceiptReferenceData(reference);
      }
      if (companyLink) {
        this.workspace.loadCompanyLinkData(companyLink);
      }

      this.workspace.reviewPreCalc.preCalc();
    },
    loadReceiptReferenceData: (data: any, paging?: any) => {
      this.workspace.receiptReference.referenceData = data;
      this.workspace.receiptReference.referencePaging = paging;
    },
    loadPossibleReceipts: (data: any, paging?: any) => {
      this.workspace.receiptReference.receiptData = data;
      this.workspace.receiptReference.receiptPaging = paging;
    },
    loadCompanyData: (data: any) => {
      this.workspace.company = data; // modal-company data
      this.workspace.receiptData.rcpt_compID = data.compID;
    },
    loadCompanyLinkData: (data: any) => {
      this.workspace.companyLinkData = data; // modal-company data
    },
    loadCommentaries: (Commentary: any, CommentaryDate: any) => {
      this.workspace.commentaryDate = CommentaryDate;
      this.workspace.commentary = Commentary;
    },
    ready: () => {
    },
  };

  openSumMode = false;
  openDeclineSumMode = false;

  aiIssuerSuggestion: any = null;
  aiIssuerNew: any = null;
  aiIssuerExtracted: any = null;

  aiSupplementMode = false;
  aiSupplementFields: string[] = [];
  aiSupplementPrevCompany: any = null;

  aiActive = false;
  aiFinishing = false;
  aiManual = false;
  aiPayloadReloading = false;
  aiPollTimer: any;
  autoApplyAiOnLoad = false;

  /************************/
  get commentary(): any[] {
    return this.workspace.commentary;
  }

  get commentaryDate(): any[] {
    return this.workspace.commentaryDate;
  }

  set Details(value: any) {
    this.details.loadDetails(
      value.caseDetails,
      value.taskDetails,
      value.caseLocation,
      value.caseOEs
    );
  }

  get openSum(): any {
    if (this.workspace
      && this.workspace.reviewPreCalc
      && this.workspace.reviewPreCalc.receiptNetto
    ) {
      return Math.round((
        (this.workspace.reviewPreCalc.receiptNetto - this.workspace.reviewPreCalc.originalNetto) + Number.EPSILON)
        * 100
      ) / 100;
    }
    return 0;
  }

  reloadOpenerView = new EventEmitter<any>();

  visibilityController = {
    /******/
    correction: true,
    note: true,
    dev_hidden_pdfviewer: true,
    /******/
    taskReportxlsx: true,
    taskReportpdf: true,
    caseReportxlsx: true,
    caseReportpdf: true,
    /******/
    defaultValue: {
      note: true,
      correction: true,
      dev_pdfviewer: false,
    },
    setDefault: () => {
      this.visibilityController.correction =
        this.visibilityController.defaultValue.correction;
      this.visibilityController.note =
        this.visibilityController.defaultValue.note;
      if (this.receiptCorrectionTable.selectedRow) {
        this.VCCorrection.initialize();
      }
      if (this.receiptNoteTable.selectedRow) {
        this.VCNote.initialize();
      }
      if (this.VCreceipt) {
        if (this.VCreceipt.receiptEditMode) {
          if (this.VCreceipt.visibilityController.companyForm) {
            if (this.VCreceipt.VCcompanyForm.companyChanged()) {
              this.VCreceipt.VCcompanyForm.beforeClose();
            }
          }
          if (this.VCreceipt.visibilityController.companyForm) {
            this.VCreceipt.visibilityController.companyForm =
              this.VCreceipt.visibilityController.defaultValue.company;
          }
          if (this.VCreceipt.rcptChanged) {
            this.showMessageSureAbout();
          } else {
            this.VCreceipt.receiptEditMode = false;
            this.VCreceipt.initialize();
          }
        }
      }
      if (this.VCreceiptReview) {
        if (this.VCreceiptReview.reviewEditMode) {
          if (this.VCreceiptReview.reviewChanged) {
            this.showMessageSureAbout();
          } else {
            this.VCreceiptReview.reviewEditMode = false;
            this.VCreceiptReview.initialize();
          }
        }
      }
    },
    /******/
    correctionSwitch: (disabled?: boolean) => {
      if (this.securityHandler.canEdit() && !disabled) {
        this.visibilityController.correction =
          !this.visibilityController.correction;
        if (!this.visibilityController.correction) {
          if (this.VCreceiptCorrectionTable.selectedRow >= 0) {
            this.VCCorrection.correction =
              this.receiptCorrectionTable.selectedRow;
          } else {
            this.VCCorrection.correction = {};
          }
        }
        this.VCCorrection.initialize();
      }
    },
    noteSwitch: (disabled?: boolean) => {
      if (this.securityHandler.canEdit() && !disabled) {
        this.visibilityController.note = !this.visibilityController.note;
        if (!this.visibilityController.note) {
          if (this.VCreceiptNoteTable.selectedRow >= 0) {
            this.VCNote.note = this.receiptNoteTable.data[this.VCreceiptNoteTable.selectedRow];
          } else {
            this.VCNote.note = {};
          }
          this.VCNote.setDefaultFocus();
        }
        this.VCNote.initialize();
      }
    },
  };
  securityHandler = {
    maxEditableState: 3, // zur Prüfung
    pickedState: 4, // in Prüfung
    finalState: [10, 20],
    canView: (): boolean => {
      return this.securityHandler.noPowerUser();
    },
    println: () => {
    },
    canEdit: (): boolean => {
      const actualState =
        this.workspace.receiptData?.rcpt_enmIdent_ReceiptStatus;

      if (!actualState) {
        return false;
      } else {
        if (actualState === 5) {
          return true;
        }

        if (
          !this.securityHandler.finalState.filter((fs) => fs === actualState)
        ) {
          return false; // Final State #Abgeschlossen
        } else if (
          this.securityHandler.noPowerUser() && // SV & Nicht zur Prüfung
          actualState < this.securityHandler.maxEditableState
        ) {
          return true;
        } else if (
          this.securityHandler.powerUser() && // EIS & Nicht zur Prüfung || Prüfung
          (actualState < this.securityHandler.maxEditableState ||
            actualState === this.securityHandler.pickedState)
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    canPick: () => {
      const actualState =
        this.workspace.receiptData?.rcpt_enmIdent_ReceiptStatus;

      return (
        this.securityHandler.powerUser() &&
        actualState === this.securityHandler.maxEditableState
      );
    },
    powerUser: () => {
      return this.excSecurity.isFeatured('RECEIPTCHECK');
    },
    noPowerUser: () => {
      return !this.excSecurity.isFeatured('RECEIPTCHECK') || this.securityHandler.powerUser();
    },
  };

  details = {
    taskDetails: {} as any,
    caseDetails: {} as any,
    caseLocation: {} as any,
    caseOEs: [] as any[],
    loadDetails: (
      caseDate: any,
      taskDate: any,
      locationData: any,
      oeData: any
    ) => {
      this.details.loadCaseDetails(caseDate);
      this.details.loadTaskDetails(taskDate);
      this.details.loadCaseOEs(oeData);
      this.details.loadCaseLocation(locationData);
    },
    loadCaseDetails: (caseData: any) => {
      this.details.caseDetails = caseData;
    },
    loadTaskDetails: (taskData: any) => {
      this.details.taskDetails = taskData;
    },
    loadCaseLocation: (SO: any) => {
      if (SO) {
        this.details.caseLocation = SO;
      } else {
        this.details.caseLocation = {};
      }
    },
    loadCaseOEs: (OEs: any) => {
      if (OEs) {
        this.details.caseOEs = OEs;
      } else {
        this.details.caseOEs = [];
      }
    },
  };
  receiptCorrectionTable = {
    selectKey: 'rcptAnno_annotationID',
    state: 1,
    selectedRow: undefined as any,
    preSelectedIndex: -1,
    preSelectedAnnotationId: '',
    rowChangeByPDFViewer: false,
    deletedByUser: false,
    canChangeSelection: false,
    searchValue: '',
    uiFilter: [],
    uiSort: [],
    data: [] as any[],
    sum: 0,
    originals: 0,
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 25,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    selectionChanged: (index: number) => {
      if (this.receiptCorrectionTable.rowChangeByPDFViewer) {
        this.receiptCorrectionTable.rowChangeByPDFViewer = false;
      } else if (index !== -1) {
        const correction = this.receiptCorrectionTable.data[index];
        const annotationId = correction[this.receiptCorrectionTable.selectKey];

        if (this.receiptPDFViewer.annotationAddMode.mode !== 'None') {
          this.VCPdfViewer.viewer.annotation.setAnnotationMode('None');
        }

        if (
          this.receiptCorrectionTable.preSelectedIndex === index &&
          this.VCreceiptCorrectionTable.selectedRow === index &&
          this.receiptCorrectionTable.preSelectedIndex !== -1
        ) {
          if (
            ExcCoreModule.Array.ExistsObject(
              this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
              'annotationId',
              annotationId
            )
          ) {
            this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.triggerAnnotationUnselectEvent();
            this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.clearSelection();
            this.receiptPDFViewer.focusAnnotation = undefined;
          }
          this.receiptCorrectionTable.selectedRow = undefined;
          this.VCreceiptCorrectionTable.selectedRow = -1;
          this.receiptCorrectionTable.preSelectedIndex = -1;
          this.visibilityController.setDefault();
        } else {
          if (
            ExcCoreModule.Array.ExistsObject(
              this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
              'annotationId',
              annotationId
            )
          ) {
            this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.selectAnnotation(
              annotationId
            );
          } else {
            this.receiptCorrectionTable.selectedRow = correction;
            this.VCreceiptCorrectionTable.selectedRow = index;
            this.receiptCorrectionTable.preSelectedIndex =
              this.VCreceiptCorrectionTable.selectedRow;
            this.visibilityController.setDefault();
          }
        }
      }
    },
    pageChanged: (page: number) => {
      if (this.receiptCorrectionTable.MetaInfo.dataPaging !== undefined) {
        this.receiptCorrectionTable.MetaInfo.dataPaging.pageNo = page;
      }
    },
    search: (value: string) => {
      this.receiptCorrectionTable.searchValue = value;
      this.receiptCorrectionTable.pageChanged(1);
    },
    ready: () => {
      if (
        !this.receiptCorrectionTable.data ||
        this.receiptCorrectionTable.data.length === 0
      ) {
        this.receiptCorrectionTable.state = 2;
      } else {
        this.receiptCorrectionTable.state = 0;
        this.receiptCorrectionTable.sumUpEntries();
        this.receiptCorrectionTable.sumUpOriginals();
      }
      this.workspace.reviewPreCalc.preCalc();
    },
    loadData: (incoming: any[]) => {
      this.receiptCorrectionTable.data = incoming;

      for (const correctionElement of this.receiptCorrectionTable.data) {
        if (correctionElement.rcptCorValues) {
          /**
           * JSON Stringify (when saving) change the number values to string values
           * During init, these become numbers again for the calculations
           */
          correctionElement.inputValues =
            JSON.parse(
              correctionElement.rcptCorValues,
              (key, value) => {
                if (key.includes('Value') || key.includes('Menge')) {
                  return parseFloat(value);
                }
                return value;
              }) || [{
              inputValueCorr: 0.00,
              inputMengeCorr: 0,
              inputValueOrig: 0.00,
              inputMengeOrig: 0,
              inputPosition: '',
            }];
          correctionElement.inputValuesCount = correctionElement.inputValues.length;
          correctionElement.inputBlock = correctionElement.inputValues.length > 1;

          /**
           * Determine if there is a set correction if
           * at least one entry in which quantity Corr or Orig is greater than 0  ⇒ activeCorrectionMode = 1 - [Menge]
           */
          Object.assign(correctionElement, {
            activeCorrectionMode: 0
          });
          correctionElement.inputValues.forEach((
            corrValue: {
              inputPosition: string,
              inputValueCorr: number,
              inputMengeCorr: number | undefined,
              inputValueOrig: number,
              inputMengeOrig: number | undefined,
            }
          ) => {
            if (corrValue.inputMengeCorr && corrValue.inputMengeOrig && (corrValue.inputMengeCorr + corrValue.inputMengeCorr) > 0) {
              if (correctionElement.activeCorrectionMode === 0) {
                Object.assign(correctionElement, {
                  activeCorrectionMode: 1
                });
              }
            }
          });
        } else {
          Object.assign(correctionElement, {
            activeCorrectionMode: 0,
            inputValues: [],
            inputValuesCount: 1,
            inputBlock: false
          });

          /**
           * Migrate oldValues to Json Value
           * or Add DefaultValue
           */
          if (
            correctionElement.rcptCorValueOrig > 0 || correctionElement.rcptCorValueCorr > 0
          ) {
            correctionElement.inputValues.push({
              inputPosition: correctionElement.rcptCorPos,
              inputValueOrig: correctionElement.rcptCorValueOrig || 0,
              inputMengeOrig: correctionElement.rcptCorMengeOrig,
              inputValueCorr: correctionElement.rcptCorValueCorr || 0,
              inputMengeCorr: correctionElement.rcptCorMengeCorr,
            });
          } else {
            correctionElement.inputValues.push({
              inputValueCorr: 0.00,
              inputMengeCorr: 0,
              inputValueOrig: 0.00,
              inputMengeOrig: 0,
              inputPosition: '',
            });
          }
        }
      }
      this.receiptCorrectionTable.ready();
    },
    getCorrSumme(posNeg: number): number {
      if (this.data && this.data.length > 0) {
        return this.sum * posNeg;
      } else {
        return 0;
      }
    },
    sumUpEntries(): void {
      this.sum = 0;
      // this.data.forEach(
      //   (cor) =>
      //     (this.sum =
      //       this.sum +
      //       cor.rcptCorValueCorr *
      //       (cor.rcptCorMengeCorr === 0 ? 1 : cor.rcptCorMengeCorr))
      // );
      this.sum =
        this.data.reduce((sumCorr: number, correctionElement: any) => {
          if (correctionElement.rcptCorAmountCorr && correctionElement.rcptCorAmountCorr > 0) {
            return sumCorr + correctionElement.rcptCorAmountCorr;
          } else if (correctionElement.rcptCorValueCorr && correctionElement.rcptCorValueCorr > 0) {
            if (correctionElement.rcptCorMengeCorr && correctionElement.rcptCorMengeCorr !== 0) {
              return sumCorr + (
                correctionElement.rcptCorValueCorr * correctionElement.rcptCorMengeCorr
              );
            } else if (correctionElement.rcptCorMengeCorr === 0) {
              return sumCorr + correctionElement.rcptCorValueCorr;
            }
          } else {
            return sumCorr;
          }
        }, 0);
    },
    sumUpOriginals(): void {
      this.originals = 0;
      // this.data.forEach(
      //   (cor) =>
      //     (this.originals =
      //       this.originals +
      //       cor.rcptCorValueOrig *
      //       (cor.rcptCorMengeOrig === 0 ? 1 : cor.rcptCorMengeOrig))
      // );
      this.originals =
        this.data.reduce((sumOrig: number, originalElement: any) => {
          if (originalElement.rcptCorAmountOrig && originalElement.rcptCorAmountOrig > 0) {
            return sumOrig + originalElement.rcptCorAmountOrig;
          } else if (originalElement.rcptCorValueOrig && originalElement.rcptCorValueOrig > 0) {
            if (originalElement.rcptCorMengeOrig && originalElement.rcptCorMengeOrig !== 0) {
              return sumOrig + (
                originalElement.rcptCorValueOrig * originalElement.rcptCorMengeOrig
              );
            } else if (originalElement.rcptCorMengeOrig === 0) {
              return sumOrig + originalElement.rcptCorValueOrig;
            }
          } else {
            return sumOrig;
          }
        }, 0);
      // console.log(tempOriginals);
    },
    isFiltered: () => {
      return (
        this.receiptCorrectionTable.MetaInfo.dataFilter &&
        JSON.stringify({}) !==
        JSON.stringify(this.receiptCorrectionTable.MetaInfo.dataFilter)
      );
    },
  };
  receiptNoteTable = {
    selectKey: 'rcptAnno_annotationID',
    state: 1,
    selectedRow: undefined as any,
    preSelectedIndex: -1,
    rowChangeByPDFViewer: false,
    deletedByUser: false,
    canChangeSelection: false,
    searchValue: '',
    uiFilter: [],
    uiSort: [],
    data: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 25,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    selectionChanged: (index: number) => {
      if (this.receiptNoteTable.rowChangeByPDFViewer) {
        this.receiptNoteTable.rowChangeByPDFViewer = false;
      } else if (index !== -1) {
        const Note = this.receiptNoteTable.data[index];
        const annotationId = Note[this.receiptNoteTable.selectKey];

        if (this.receiptPDFViewer.annotationAddMode.mode !== 'None') {
          this.VCPdfViewer.viewer.annotation.setAnnotationMode('None');
        }

        if (
          this.receiptNoteTable.preSelectedIndex === index &&
          this.VCreceiptNoteTable.selectedRow === index &&
          this.receiptNoteTable.preSelectedIndex !== -1
        ) {
          if (
            ExcCoreModule.Array.ExistsObject(
              this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
              'annotationId',
              annotationId
            )
          ) {
            this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.clearSelection();
            this.receiptPDFViewer.focusAnnotation = undefined;
          }
          this.receiptNoteTable.selectedRow = undefined;
          this.VCreceiptNoteTable.selectedRow = -1;
          this.receiptNoteTable.preSelectedIndex = -1;
          this.visibilityController.setDefault();
        } else if (
          ExcCoreModule.Array.ExistsObject(
            this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
            'annotationId',
            annotationId
          )
        ) {
          this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.selectAnnotation(
            annotationId
          );
        } else {
          this.receiptNoteTable.selectedRow = Note;
          this.VCreceiptNoteTable.selectedRow = index;
          this.receiptNoteTable.preSelectedIndex =
            this.VCreceiptNoteTable.selectedRow;
          this.visibilityController.setDefault();
        }
      }
    },
    pageChanged: (page: number) => {
      if (this.receiptNoteTable.MetaInfo.dataPaging !== undefined) {
        this.receiptNoteTable.MetaInfo.dataPaging.pageNo = page;
      }
      this.receiptNoteTable.ready();
    },
    search: (value: string) => {
      this.receiptNoteTable.searchValue = value;
      this.receiptNoteTable.pageChanged(1);
    },
    loadData: (incoming: any[]) => {
      this.receiptNoteTable.data = incoming;
      this.receiptNoteTable.ready();
    },
    ready: () => {
      if (
        !this.receiptNoteTable.data ||
        this.receiptNoteTable.data.length === 0
      ) {
        this.receiptNoteTable.state = 2;
      } else {
        this.receiptNoteTable.state = 0;
      }
    },
    isFiltered: () => {
      return (
        this.receiptNoteTable.MetaInfo.dataFilter &&
        JSON.stringify({}) !==
        JSON.stringify(this.receiptCorrectionTable.MetaInfo.dataFilter)
      );
    },
  };
  receiptPDFViewer = {
    focusAnnotation: undefined as any,
    annotationAddMode: {
      // node_modules/@syncfusion/ej2-pdfviewer/src/pdfviewer/base/types.d.ts
      mode: 'None', // AnnotationTyp Zeile 28
      dynamicStampItem: undefined as any, // DynamicStampItem Zeile 148
      signStampItem: undefined as any, // SignStampItem Zeile 159
      standardBusinessStampItem: undefined as any // StandardBusinessStampItem Zeile 169
    },
    annotationAdded: (event: any) => {
      if (this.securityHandler.canEdit()) {
        this.receiptPDFViewer.focusAnnotation = ExcCoreModule.Array.GetObject(
          this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
          'annotationId',
          event.annotationId
        );

        switch (this.VCrightTabControl.selectedtab) {
          case 1:
            this.receiptCorrectionTable.rowChangeByPDFViewer = true;
            this.VCreceiptCorrectionTable.selectedRow = -1;
            this.VCCorrection.correction = {};
            this.VCCorrection.initialize();
            this.receiptCorrection();
            break;
          case 2:
            if (this.openSumMode) {
              this.receiptCorrectionTable.rowChangeByPDFViewer = true;
              this.receiptCorrection();
            } else {
              this.receiptNoteTable.rowChangeByPDFViewer = true;
              this.VCreceiptNoteTable.selectedRow = -1;
              this.VCNote.note = {};
              this.VCNote.initialize();
              this.receiptNote();
            }
            break;
          case 3:
            this.receiptCorrectionTable.rowChangeByPDFViewer = true;
            this.receiptCorrection();
            break;
        }
        this.saveAnnotatedFile();
      }
    },
    annotationDeleted: (event: any) => {
      if (!this.securityHandler.canEdit()) {
        return;
      }
      this.receiptPDFViewer.focusAnnotation = ExcCoreModule.Array.GetObject(
        this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
        'annotationId',
        event.annotationId
      );
      if (
        ExcCoreModule.Array.ExistsObject(
          this.receiptCorrectionTable.data,
          this.receiptCorrectionTable.selectKey,
          event.annotationId
        )
      ) {
        this.receiptCorrectionTable.rowChangeByPDFViewer = true;
        this.deleteCorrection(this.receiptCorrectionTable.rowChangeByPDFViewer);
        this.VCreceiptCorrectionTable.selectedRow = -1;
        this.receiptCorrectionTable.preSelectedIndex = -1;
        this.receiptPDFViewer.annotationUnSelectCurrentForm();
      } else if (
        ExcCoreModule.Array.ExistsObject(
          this.receiptNoteTable.data,
          this.receiptNoteTable.selectKey,
          event.annotationId
        )
      ) {
        this.receiptNoteTable.rowChangeByPDFViewer = true;
        this.deleteNote(this.receiptNoteTable.rowChangeByPDFViewer);
        this.VCreceiptNoteTable.selectedRow = -1;
        this.receiptNoteTable.preSelectedIndex = -1;
        this.receiptPDFViewer.annotationUnSelectCurrentForm();
      }
    },
    annotationChanged: (event: any) => {
      this.saveChangedAnnotation(event).then();
      this.saveAnnotatedFile();
    },
    annotationSelected: (event: any) => {
      if (!this.securityHandler.canEdit()) {
        return;
      }
      if (event) {
        this.receiptPDFViewer.focusAnnotation = ExcCoreModule.Array.GetObject(
          this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
          'annotationId',
          event.annotationId
        );
        if (this.VCrightTabControl.selectedtab === 1) {
          if (
            ExcCoreModule.Array.ExistsObject(
              this.receiptCorrectionTable.data,
              this.receiptCorrectionTable.selectKey,
              event.annotationId
            )
          ) {
            const index = ExcCoreModule.Array.GetObjectIndex(
              this.receiptCorrectionTable.data,
              this.receiptCorrectionTable.selectKey,
              event.annotationId
            );
            // console.log(
            //   'Select-annotation:',
            //   this.receiptCorrectionTable.preSelectedIndex,
            //   '>',
            //   index
            // );

            this.receiptCorrectionTable.rowChangeByPDFViewer = true;
            this.VCreceiptCorrectionTable.selectedRow = index;
            this.receiptCorrectionTable.selectedRow =
              this.receiptCorrectionTable.data[index];

            this.receiptCorrectionTable.preSelectedIndex =
              this.VCreceiptCorrectionTable.selectedRow;
            this.VCCorrection.correction =
              this.receiptCorrectionTable.selectedRow;

            this.VCCorrection.initialize();
            // console.log('Select-annotation:', index);
          } else {
            this.receiptCorrectionTable.rowChangeByPDFViewer = true;
            this.receiptCorrectionTable.preSelectedIndex = -1;
            this.VCreceiptCorrectionTable.selectedRow = -1;
            this.visibilityController.setDefault();
          }
        } else if (this.VCrightTabControl.selectedtab === 2) {
          if (
            ExcCoreModule.Array.ExistsObject(
              this.receiptNoteTable.data,
              this.receiptNoteTable.selectKey,
              event.annotationId
            )
          ) {
            const index = ExcCoreModule.Array.GetObjectIndex(
              this.receiptNoteTable.data,
              this.receiptNoteTable.selectKey,
              event.annotationId
            );

            this.receiptNoteTable.rowChangeByPDFViewer = true;
            this.VCreceiptNoteTable.selectedRow = index;
            this.receiptNoteTable.selectedRow =
              this.receiptNoteTable.data[index];

            this.receiptNoteTable.preSelectedIndex =
              this.VCreceiptNoteTable.selectedRow;
            this.VCNote.note = this.receiptNoteTable.selectedRow;

            this.VCNote.initialize();
            // console.log('Select-annotation:', index);
          } else {
            this.receiptNoteTable.rowChangeByPDFViewer = true;
            this.VCreceiptNoteTable.selectedRow = -1;
            this.receiptNoteTable.preSelectedIndex = -1;
            this.visibilityController.setDefault();
          }
        }
        if (this.receiptPDFViewer.annotationAddMode.mode !== 'None') {
          this.VCPdfViewer.viewer.annotation.setAnnotationMode('None');
        }
      }
    },
    annotationUnselected: (event: any) => {
      if (
        ExcCoreModule.Array.ExistsObject(
          this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
          'annotationId',
          event.annotationId
        )
      ) {
        if (
          this.VCrightTabControl.selectedtab === 1 &&
          this.receiptCorrectionTable.selectedRow
        ) {
          this.receiptCorrectionTable.rowChangeByPDFViewer = true;
          this.receiptCorrectionTable.preSelectedIndex = -1;
          this.VCreceiptCorrectionTable.selectedRow = -1;
          this.visibilityController.setDefault();
        } else if (
          this.VCrightTabControl.selectedtab === 2 &&
          this.receiptNoteTable.selectedRow
        ) {
          this.receiptNoteTable.rowChangeByPDFViewer = true;
          this.VCreceiptNoteTable.selectedRow = -1;
          this.receiptNoteTable.preSelectedIndex = -1;
          this.visibilityController.setDefault();
        }
        this.receiptPDFViewer.focusAnnotation = undefined;
        this.receiptPDFViewer.annotationUnSelectCurrentForm();
      }
    },
    annotationUnSelectCurrentForm: () => {
      if (
        this.visibilityController.correction ||
        this.visibilityController.note
      ) {
        if (this.VCNote) {
          this.VCNote.note = {};
          this.VCNote.initialize();
        }
        if (this.VCCorrection) {
          this.VCCorrection.correction = {};
          this.VCCorrection.initialize();
        }
      }
    },
    annotationModeChanged: (event: any): void => {
      this.receiptPDFViewer.annotationAddMode = event;

      if (event.mode === 'None') {
        this.saveAnnotatedFile();
      }
    },
    pageClicked: (): void => {
      if (this.receiptPDFViewer.annotationAddMode.mode === 'HandWrittenSignature') {
        this.VCPdfViewer.viewer.annotation.setAnnotationMode('HandWrittenSignature');
      }
    },
    signatureSelect: ($event: any): void => {
      this.saveAnnotatedFile();
    },
    signatureUnSelect: ($event: any): void => {
      this.saveAnnotatedFile();
    },
    onDocumentLoaded: async () => {
      this.showMessageSomething(
        this.getRessource('MessageViewerReady'),
        'fal fa-check',
        'bg-green'
      );

      // Self repair
      if (this.VCPdfViewer
        && this.VCPdfViewer.VCSyncfusionPdfViewer
        && this.VCPdfViewer.VCSyncfusionPdfViewer.annotation
        && this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule
        && this.VCPdfViewer.VCSyncfusionPdfViewer.viewerBase
      ) {
        this.VCPdfViewer.VCSyncfusionPdfViewer.viewerBase.deleteAnnotations();
        this.VCPdfViewer.VCSyncfusionPdfViewer.annotation.clearAnnotationStorage();
        this.VCPdfViewer.VCSyncfusionPdfViewer.deleteAnnotations();

        for (const annotation of JSON.parse(
          this.workspace.receiptData.AggrAnnotation
        )) {
          this.VCPdfViewer.VCSyncfusionPdfViewer.addAnnotation(annotation);
        }

        this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.initializeCollection();
        this.saveAnnotatedFile();
      }

      this.VCPdfViewer.enableAnnotationTools(false);

      return of(!this.init).toPromise();
    },
    onViewerReady: async () => {
      this.showMessageSomething(
        this.getRessource('MessageViewerReady'),
        'fal fa-check',
        'bg-green'
      );
      this.chDecRef.markForCheck();
      return of(!this.init).toPromise();
    }
  };
  responseHandler = {
    create(
      result: any,
      rcptAnnotation: any,
      VCPdfViewer: any,
      Data: any
    ): void {
      if (result.success && result.data) {
        Data.loadData(result.data);
        // VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.selectAnnotation(
        //   rcptAnnotation
        // );
        Data.ready();
      }
    },
    edit(result: any, rcptAnnotation: any, VCPdfViewer: any, Data: any): void {
      Data.loadData(result.data);
      VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.selectAnnotation(
        rcptAnnotation
      );
      Data.ready();
    },
    delete(
      result: any,
      annotation: any,
      VCPdfViewer: any,
      Data: any,
      rowChangedByViewer: boolean
    ): void {
      if (result.success && result.data) {
        Data.loadData(result.data);
        if (annotation && !rowChangedByViewer) {
          if (
            ExcCoreModule.Array.ExistsObject(
              VCPdfViewer.annotationCollection,
              'annotationId',
              annotation.annotationId
            )
          ) {
            VCPdfViewer.annotationModule.deleteAnnotationById(
              annotation.annotationId
            );
          }
        }
        Data.ready();
      }
    },
  };

  constructor(
    private chDecRef: ChangeDetectorRef,
    private excRest: ExcRestService,
    public excSecurity: ExcSecurityService,
    private modalService: ExgModalService,
    private appSvc: ApplicationService,
    public enumSvc: EnumerationService,
    public userSettingsSvc: UserSettingsService
  ) {
    super();

    setInterval(() => {
      this.chDecRef.detectChanges();
    }, 100);
  }

  ngOnInit(): void {
    this.registerEvents();
    this.initialize();
  }

  ngAfterViewInit(): void {
    // this.setPdfViewerHeight();
  }

  ngOnDestroy(): void {
    clearInterval(this.aiPollTimer);
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      if (this.tabinstance.Active) {
        this.loadCheckviewData();
      }
    });
    this.reloadOpenerView.subscribe(() => {
      if (this.Data?.reloadOpenerView) {
        this.Data?.reloadOpenerView();
      }
    });
    this.Events.Receipt.UploadDialog.Replaced.subscribe(() => {
      this.loadCheckviewData();
      this.workspace.hideViewer = true;
      setTimeout(() => {
        this.workspace.hideViewer = false;
      }, 500);
    });
  }

  initialize(): void {
    const SELF = this;

    this.viewerurl = this.excRest.computeUrl('ReceiptR_BinaryAnnotated', {
      rcptID: this.Data.rcptID,
    });

    SELF.loadCheckviewData(true);
    SELF.rightTabs = [
      {
        get caption(): string {
          return SELF.getGlobal('Details');
        },
        icon_class: SELF.getResource('DetailsIcon'),
        get disabled(): boolean {
          return SELF.workspace.isLoadingPreview || SELF.aiRunning();
        },
      },
      {
        get caption(): string {
          return SELF.getResource('tab.Position');
        },
        icon_class: SELF.getResource('subEntities.SummaryIcon'),
        get disabled(): boolean {
          return (
            !SELF.securityHandler.canView() || SELF.workspace.isLoadingPreview || SELF.aiRunning()
          );
        },
      },
      {
        get caption(): string {
          return SELF.getGlobal('Notes');
        },
        icon_class: SELF.getResource('subEntities.NotesIcon'),
        get disabled(): boolean {
          return (
            !SELF.securityHandler.canView() || SELF.workspace.isLoadingPreview || SELF.aiRunning()
          );
        },
      },
      {
        get caption(): string {
          return SELF.getRessource('tab.Review');
        },
        icon_class: SELF.getResource('review.Icon'),
        get disabled(): boolean {
          return SELF.workspace.isLoadingPreview || SELF.aiRunning();
        },
      },
    ];
    if (this.tabinstance) {
      this.tabinstance.BeforeClose = () => {
        this.reloadOpenerView.emit();

        if (this.VCPdfViewer?.VCSyncfusionPdfViewer) {
          this.VCPdfViewer.VCSyncfusionPdfViewer.unload();
        }
        return this.showMessageSureAbout(true);
      };
    }
  }

  loadCheckviewData(pickable?: boolean): void {
    const WORKSPACE = this.workspace;
    const SELF = this;
    WORKSPACE.isLoading = true;

    this.excRest
      .get(
        this.excRest.computeUrl('ReceiptR_Checkview', {
          rcptID: this.Data.rcptID,
        })
      )
      .subscribe((response: any) => {
        if (response && response.data) {
          const RESPONSE = response.data;
          SELF.tabinstance.Label = RESPONSE.Receipt.rcptFileName;
          /****************/
          SELF.receiptCorrectionTable.loadData(RESPONSE.Corrections);
          SELF.receiptNoteTable.loadData(RESPONSE.Notes);
          WORKSPACE.aiResult = RESPONSE.AiResult;
          WORKSPACE.aiQueue = RESPONSE.AiQueue;
          SELF.startAiFlow();
          /****************/
          WORKSPACE.loadData(
            RESPONSE.Receipt,
            RESPONSE.Company,
            {
              caseDetails: RESPONSE.Auftrag,
              taskDetails: RESPONSE.Vorgang,
              caseOEs: RESPONSE.OEs,
              caseLocation: RESPONSE.Location,
            },
            RESPONSE.Reference,
            RESPONSE.CompanyLink
          );
          WORKSPACE.loadCommentaries(
            RESPONSE.Commentary,
            RESPONSE.CommentaryDate
          );
          if (pickable && this.securityHandler.canPick()) {
            this.pickReceiptReview();
          }
          if (
            this.VCreceipt
            && this.securityHandler.canEdit()
            && RESPONSE.Receipt.rcpt_enmIdent_ReceiptStatus === 1
          ) {
            this.VCreceipt.switchEditMode(this.securityHandler.canEdit());
          }
          this.VCreceipt.initialize(true);
          this.workspace.isLoading = false;
          this.checkDuplicates(false);
          this.checkCanRestoreDetails();
          if (this.autoApplyAiOnLoad) {
            this.autoApplyAiOnLoad = false;
            setTimeout(() => {
              this.applyAiSuggestions();
              this.aiActive = false;
              this.aiFinishing = false;
              this.chDecRef.markForCheck();
            }, 0);
          }
          this.chDecRef.markForCheck();
        }
      });
  }

  aiJobRunning(): boolean {
    if (!this.aiEnabled()) {
      return false;
    }
    const s = this.workspace.aiQueue?.kiqStatus;
    return !!s && s !== 'completed' && s !== 'failed' && s !== 'failedApiCall';
  }

  aiRunning(): boolean {
    return this.aiActive;
  }

  aiEnabled(): boolean {
    return this.excSecurity.isFeatured('RECEIPTAIRESULT');
  }

  aiStageText(): string {
    const stage = this.aiFinishing ? 'writeback' : (this.workspace.aiQueue?.currentStage || 'queued');
    const text = this.getRessource('ki.stage.' + stage);
    return text.indexOf('ki.stage.') >= 0 ? '' : text;
  }

  aiReasonText(): string {
    const code = this.workspace.aiResult?.reasonCode;
    if (!code) {
      return '';
    }
    const text = this.getRessource('ki.reason.' + code);
    return text.indexOf('ki.reason.') >= 0 ? code : text;
  }

  startAiFlow(): void {
    if (!this.aiEnabled() || this.aiManual || this.aiActive || !this.aiJobRunning()) {
      return;
    }
    this.aiActive = true;
    this.refreshAiStatus();
    clearInterval(this.aiPollTimer);
    this.aiPollTimer = setInterval(() => this.refreshAiStatus(), 3000);
  }

  finishAiFlow(): void {
    clearInterval(this.aiPollTimer);
    this.aiFinishing = true;
    this.autoApplyAiOnLoad = true;
    this.loadCheckviewData();
  }

  aiEditManually(): void {
    this.aiActive = false;
    this.aiManual = true;
    if (this.VCreceipt &&
        this.securityHandler.canEdit() &&
        !this.VCreceipt.receiptEditMode)
    {
      this.VCreceipt.switchEditMode(true);
    }
    this.chDecRef.markForCheck();
  }

  refreshAiStatus(): void {
    this.excRest
      .get(this.excRest.computeUrl('ReceiptR_AiStatus', {rcptID: this.Data.rcptID}))
      .subscribe((response: any) => {
        if (response && response.data) {
          this.workspace.aiResult = response.data.AiResult;
          this.workspace.aiQueue = response.data.AiQueue;
          const s = this.workspace.aiQueue?.kiqStatus;
          if ((s === 'completed' || s === 'failed' || s === 'failedApiCall') && !this.aiFinishing) {
            if (this.aiManual) {
              clearInterval(this.aiPollTimer);
            } else {
              this.finishAiFlow();
            }
          }
          this.chDecRef.markForCheck();
        }
      });
  }

  applyAiSuggestions(): void {
    if (!this.aiEnabled()) {
      return;
    }
    const p = this.aiPayload();
    if (!p) {
      if (this.workspace.aiResult?.status &&
        this.workspace.aiResult.status !== 'failed' &&
        !this.aiPayloadReloading) {

        this.aiPayloadReloading = true;
        this.autoApplyAiOnLoad = true;
        this.loadCheckviewData();
      }
      return;
    }
    this.aiPayloadReloading = false;
    if (
      !p.receipt ||
      !this.VCreceipt ||
      this.workspace.aiResult?.status === 'failed'
    ){
      return;
    }
    if (this.securityHandler.canEdit() && !this.VCreceipt.receiptEditMode) {
      this.VCreceipt.switchEditMode(true);
    }

    const c = this.VCreceipt.receiptClone;
    if (!c) {
      return;
    }
    const r = p.receipt;
    if (r.rcptType != null) {
      c.rcpt_enmIdent_ReceiptType = r.rcptType.enmIdent;
    }
    if (r.rcptNumber != null) {
      c.rcptNumber = r.rcptNumber;
    }
    if (r.rcptDate) {
      c.rcptDate = new Date(r.rcptDate);
    }
    if (r.rcptObject != null) {
      c.rcptObject = JSON.stringify(r.rcptObject);
    }
    if (r.rcptNetSum != null) {
      c.rcptNetSum = r.rcptNetSum;
    }
    if (r.rcptVATRate != null) {
      c.rcptVATRate = r.rcptVATRate;
    }
    if (r.rcptGrossSum != null) {
      c.rcptGrossSum = r.rcptGrossSum;
    }
    const ir = p.issuerResults;
    const first = (ir && ir.length > 0) ? ir[0] : null;
    this.aiIssuerSuggestion = (first && first.matchedIssuer && first.matchedIssuer.compID) ? first.matchedIssuer : null;
    this.aiIssuerNew = (first && first.newIssuerSuggestion && first.extractedCompany) ? first.extractedCompany : null;
    this.aiIssuerExtracted = first ? first.extractedCompany : null;

    if (this.aiIssuerExtracted && this.aiIssuerExtracted.compCountry){
      this.aiIssuerExtracted.compCountry = this.aiIssuerExtracted.compCountry.enmIdent;
    }

    this.chDecRef.markForCheck();
  }



  aiIssuerMismatchList(comp: any): any[] {
    const e = this.aiIssuerExtracted;
    const changes: any[] = [];
    if (!e || !comp) {
      return changes;
    }
    for (const field of Object.keys(e)) {
      const kiValue = e[field];
      const dbValue = comp[field];
      if (field.startsWith('comp') &&
        kiValue &&
        kiValue !== dbValue
      ) {
        changes.push({field, value: kiValue});
      }
    }
    return changes;
  }

  aiIssuerHasMismatch(): boolean {
    const comp = this.workspace.company;
    const suggestion = this.aiIssuerSuggestion;
    return !!(this.workspace.receiptData?.rcpt_compID &&
      suggestion &&
      comp?.compID?.toLowerCase() === suggestion.compID?.toLowerCase() &&
      this.aiIssuerMismatchList(comp).length > 0);
  }

  openAiIssuerSupplement(sourceComp?: any): void {
    const comp = sourceComp || this.workspace.company;
    console.log('comp', comp);
    const changes = this.aiIssuerMismatchList(comp);
    console.log('changes', changes);

    if (changes.length === 0) {
      return;
    }
    const merged = {...comp};
    changes.forEach(change => merged[change.field] = change.value);
    this.aiSupplementFields = changes.map(change => this.enumSvc.getFieldCaption('Company', change.field));
    this.aiSupplementPrevCompany = this.workspace.company;
    this.workspace.company = comp;
    if (!this.VCreceipt.visibilityController.companyForm) {
      this.VCreceipt.visibilityController.companySwitch();
    }
    this.aiSupplementMode = true;
    this.chDecRef.detectChanges();
    this.VCreceipt.VCcompanyForm.CompanyDataClone = merged;
    this.chDecRef.markForCheck();
  }

  aiIssuerName(): string {
    const s = this.aiIssuerSuggestion || this.aiIssuerNew;
    return s ? s.compName : '';
  }

  aiIssuerPending(): boolean {
    return !!(this.aiIssuerSuggestion || this.aiIssuerNew) &&
           !this.workspace.receiptData?.rcpt_compID;
  }

  acceptAiIssuer(): void {
    if (this.aiIssuerSuggestion) {
      this.applyAiIssuer();
    } else if (this.aiIssuerNew) {
      this.applyAiIssuerNew();
    }
  }

  rejectAiIssuer(): void {
    this.aiIssuerSuggestion = null;
    this.aiIssuerNew = null;
    if (!this.workspace.receiptData?.rcpt_compID){
      this.workspace.company = {};
    }
    this.chDecRef.markForCheck();
  }

  applyAiIssuerNew(): void {
    const e = this.aiIssuerNew;

    if (!this.VCreceipt.visibilityController.companyForm) {
      this.VCreceipt.visibilityController.companySwitch();
    }
    this.VCreceipt.VCcompanyForm.CompanyDataClone = {
      ...e,
        compID: undefined
    };
    this.aiIssuerNew = null;
    this.chDecRef.markForCheck();
  }

  applyAiIssuer(): void {
    const s = this.aiIssuerSuggestion;
    if (!s || !s.compID){
      return;
    }
    this.excRest.get(
        this.excRest.computeUrl('CompanyGROOT', {compID: s.compID}),
        {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
      )
      .subscribe((result: any) => {
        if (result && result.success && result.data.Company) {
          const dbComp = result.data.Company;
          if (this.aiIssuerMismatchList(dbComp).length > 0) {
            this.openAiIssuerSupplement(dbComp);
          } else {
            this.receiptCompanyU(s.compID, dbComp.compUPT);
          }
        }
     });
  }

  saveReceipt(cancelToken?: boolean): void {
    if (!cancelToken && this.securityHandler.canEdit()) {
      if (
        (
          this.VCreceipt.rcptChanged ||
          this.VCreceipt.receipt.rcpt_enmIdent_ReceiptStatus === 1
        ) &&
        !this.workspace.isLoading &&
        !this.aiRunning()
      ) {
        this.workspace.isLoading = true;
        this.excRest
          .put(
            this.excRest.computeUrl('ReceiptU', {rcptID: this.Data.rcptID}),
            this.VCreceipt.receiptClone
          )
          .subscribe((ret: any) => {
            if (ret && ret.success) {
              this.workspace.loadData(ret.data.Receipt);
              this.workspace.reviewPreCalc.preCalc();
              this.showMessageSomething(
                this.getResource('SavedChanges'),
                'far fa-save',
                'bg-green'
              );
              this.checkDuplicates(true);
            }
            this.workspace.isLoading = false;
            this.VCreceipt.switchEditMode(this.securityHandler.canEdit());
          });
      }
    } else {
      this.modalService.showToast(
        this.getResource('Canceled'),
        'md-toast',
        'far fa-window-close'
      );
      this.VCreceipt.initialize(true, true);
    }
  }

  checkCanRestoreDetails(): void {
    if (this.securityHandler.canEdit()
        && !this.workspace.isLoading
        && this.Data.checkRestore
        && this.workspace.receiptData.rcptDetailsBackup) {
      this.modalService
        .showSimple(
          this.getRessource('restoreDetails.Header'),
          this.getRessource('restoreDetails.Text'),
          true,
          true,
          this.getRessource('restoreDetails.btnOK'),
          this.getGlobal('Cancel')
        ).subscribe((rtVal: any) => {
          if (rtVal) {
            this.receiptRestoreDetails();
          }
          this.Data.checkRestore = false;
        });
    }
  }

  receiptRestoreDetails(): void {
    if (this.securityHandler.canEdit() && !this.workspace.isLoading) {
      this.workspace.isLoading = true;
      this.excRest
        .put(
          this.excRest.computeUrl('ReceiptU_RestoreDetails', {rcptID: this.Data.rcptID}),
          {rcptUPT: this.workspace.receiptData.rcptUPT}
        )
        .subscribe((ret: any) => {
          if (ret && ret.success) {
            this.workspace.loadData(ret.data.Receipt);
            this.workspace.reviewPreCalc.preCalc();
            this.showMessageSomething(
              this.getResource('SavedChanges'),
              'far fa-save',
              'bg-green'
            );
          }
          this.workspace.isLoading = false;
        });
    }
  }

  rightTabs_tabChange(event: number): void {
    this.visibilityController.setDefault();
    this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.clearSelection();
    this.receiptPDFViewer.focusAnnotation = undefined;

    if (this.VCreceiptCorrectionTable.selectedRow >= -1) {
      this.VCreceiptCorrectionTable.selectedRow = -1;
    }
    if (this.VCreceiptNoteTable.selectedRow >= -1) {
      this.VCreceiptNoteTable.selectedRow = -1;
    }

    switch (event) {
      case 0:
        this.VCPdfViewer.enableAnnotationTools(false);
        this.loadCheckviewData(this.securityHandler.canPick());
        break;
      case 1:
        this.VCPdfViewer.enableAnnotationTools(this.securityHandler.canEdit());
        this.receiptCorrectionTable.ready();
        break;
      case 2:
        this.VCPdfViewer.enableAnnotationTools(this.securityHandler.canEdit());
        this.receiptNoteTable.ready();
        break;
      case 3:
        this.saveAnnotatedFile();
        this.loadCheckviewData();
        this.VCPdfViewer.enableAnnotationTools(false);
        this.VCreceiptReview.initialize();
        break;
      default:
        break;
    }
  }

  saveAnnotatedFile(): void {
    if (this.VCPdfViewer) {
      this.workspace.reviewPreCalc.preCalc();

      this.VCPdfViewer.getFile()
        .then((formData) => {
          formData.set(
            'DataObject',
            JSON.stringify({
              rcptUPT: this.workspace.receiptData.rcptUPT,
              rcpt_filestreamIDAnnotated:
              this.workspace.receiptData?.rcpt_filestreamIDAnnotated,
            })
          );
          return formData;
        })
        .then((fData) => {
          this.excRest
            .post(
              this.excRest.computeUrl('ReceiptCU_FileAnnotated', {
                rcptID: this.Data.rcptID,
              }),
              fData
            )
            .subscribe((ret: any) => {
            });
        });
    }
  }

  async saveChangedAnnotation(event: any): Promise<void> {
    // console.log('save: ', ExcCoreModule.Array.GetObject(
    //   this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
    //   'annotationId',
    //   event.annotationId
    // ));
    if (this.VCPdfViewer
      && this.securityHandler.canEdit()
      && ExcCoreModule.Array.GetObject(
        this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
        'annotationId',
        event.annotationId
      )
    ) {
      this.excRest
        .put(
          this.excRest.computeUrl('ReceiptAnnotationU', {
            rcptID: this.Data.rcptID, annotationID: event.annotationId,
          }),
          {
            rcptAnnoAnnotation: JSON.stringify(ExcCoreModule.Array.GetObject(
              this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
              'annotationId',
              event.annotationId
            ))
          }
        )
        .subscribe((ret: any) => {
        });
    }
  }

  editFocusAnnotation(textValue: string): any {
    if (
      this.receiptPDFViewer.focusAnnotation &&
      this.receiptPDFViewer.focusAnnotation.subject === 'Text Box'
    ) {
      this.receiptPDFViewer.focusAnnotation.dynamicText = textValue;
      this.receiptPDFViewer.focusAnnotation.notes = textValue;

      this.VCPdfViewer.VCSyncfusionPdfViewer.annotation.modifyDynamicTextValue(
        textValue,
        this.receiptPDFViewer.focusAnnotation.annotationId
      );
      this.VCPdfViewer.VCSyncfusionPdfViewer.annotation.editAnnotation(
        this.receiptPDFViewer.focusAnnotation
      );

      this.saveAnnotatedFile();
    }
    return this.receiptPDFViewer.focusAnnotation;
  }

  receiptCorrection(cancelToken?: boolean): void {
    if (
      this.securityHandler.canEdit() &&
      !this.workspace.isLoading &&
      !this.workspace.isLoadingPreview
    ) {
      if (!cancelToken) {
        if (this.VCreceiptCorrectionTable.selectedRow === -1 || this.openSumMode) {
          // console.log('receiptCorrection - create');
          this.createReceiptCorrection(cancelToken);
        } else if (this.VCreceiptCorrectionTable.selectedRow !== -1) {
          // console.log('receiptCorrection - edit');
          this.editReceiptCorrection(cancelToken);
        }
      } else if (!this.visibilityController.correction) {
        this.visibilityController.correctionSwitch();
      }
    }
  }

  formatCorrectionAnnotation(Values: any): string {
    return `${
      Values.activeCorrectionMode === 0 ? `Pauschal | ` : 'Mengen | '
    }` +
    `${Values.inputMengeCorr > 0 ? Values.inputMengeCorr + ' | ' : ''}` +
    `${Values.inputValueCorr} €${
      Values.inputMengeCorr > 0
        ? ` | ${-1 * (Values.inputValueCorr * Values.inputValueCorr)} €`
        : ''
    }` +
    Values?.inputComment
      ? String.fromCharCode(13) + `${Values?.inputComment}`
      : '';
  }

  // Input: PDF-Viewer-Annotation
  createReceiptCorrection(cancelToken?: boolean): void {
    const correction = this.VCCorrection.getValues();
    const annotation = this.receiptPDFViewer.focusAnnotation;

    const remainingAmount = [
      {
        inputPosition: '',
        inputValueCorr: this.openSum,
        inputValueOrig: this.openSum
      }];
    const declineRemainingAmount = [
      {
        inputPosition: '',
        inputValueCorr: 0,
        inputValueOrig: this.openSum
      }];

    console.log(this.VCPdfViewer.viewer.annotation.activeAnnotationMode);

    const rcptCorType =
      this.VCPdfViewer.viewer.annotation.activeAnnotationMode.dynamicStampItem === 'check' ? 1 :
        this.VCPdfViewer.viewer.annotation.activeAnnotationMode.dynamicStampItem === 'circle' ? 2 :
          this.VCPdfViewer.viewer.annotation.activeAnnotationMode.dynamicStampItem === 'cross' ? 3 :
            this.openSumMode || this.openDeclineSumMode ? 99
              : 0;

    if (!cancelToken) {
      if (
        ExcCoreModule.Array.ExistsObject(
          this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
          'annotationId',
          annotation.annotationId
        )
      ) {
        this.workspace.isLoading = true;
        this.excRest
          .post(
            this.excRest.computeUrl('ReceiptCorrectionC', {
              rcptID: this.Data.rcptID,
            }),
            {
              rcptAnnoAnnotation: JSON.stringify(annotation),
              rcptAnno_annotationID: annotation.annotationId,
              rcptCorAmount: this.openSumMode || this.openDeclineSumMode ? this.openSum : 0,
              rcptCorAmountCorr: this.openSumMode ? this.openSum : 0,
              rcptCorAmountOrig: this.openSumMode || this.openDeclineSumMode ? this.openSum : 0,

              rcptCorValuesCount: (this.openSumMode || this.openDeclineSumMode) ? 1 : 0,
              rcptCorValues: this.openSumMode ?
                                JSON.stringify(remainingAmount) :
                                this.openDeclineSumMode ?
                                  JSON.stringify(declineRemainingAmount)
                                  : '',
              rcptCorTitle: this.openSumMode ? 'Differenzbetrag freigegeben' :
                              this.openDeclineSumMode ? 'Differenzbetrag abgelehnt'
                                : '',

              rcptCorType,
            },
            {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
          )
          .subscribe((result: any) => {
            if (this.openSumMode) {
              this.workspace.reviewPreCalc.preCalc();
              this.openSumMode = false;
              this.openDeclineSumMode = false;
            }
            this.workspace.isLoading = false;
            this.responseHandler.create(
              result,
              annotation,
              this.VCPdfViewer,
              this.receiptCorrectionTable
            );
          });
      }
    }
  }

  // Input: Table-Row
  editReceiptCorrection(cancelToken?: boolean): void {
    const rcptCorrection = this.receiptCorrectionTable.selectedRow;
    const correction = this.VCCorrection.getValues().valuesClone;
    const preCalc = this.VCCorrection.getValues().preCalcValues;
    const annotation = this.editFocusAnnotation(correction.inputComment);

    if (!cancelToken) {
      console.log(preCalc);
      this.workspace.isLoading = true;
      // Object.assign(annotation, {
      //   bodyValue: this.formatCorrectionAnnotation(correction),
      // });

      this.excRest
        .put(
          this.excRest.computeUrl('ReceiptCorrectionU', {
            rcptID: this.Data.rcptID,
            annotationID: annotation.annotationId,
          }),
          {
            rcptCorPos: correction?.inputPosition,
            rcptCorValueOrig: correction.inputValueOrig,
            rcptCorMengeOrig: correction.inputMengeOrig,
            rcptCorValueCorr: correction.inputValueCorr,
            rcptCorMengeCorr: correction.inputMengeCorr,
            rcptCorAmount: preCalc.valueCorr,
            rcptCorAmountCorr: preCalc.valueCorr,
            rcptCorAmountOrig: preCalc.valueOrig,
            rcptCorValuesCount: correction.inputValuesCount,
            rcptCorValues: JSON.stringify(correction.inputValues),
            rcptCorTitle: correction.inputTitle,
            rcptCorSortPos: correction.inputSort,
            rcptCorDesc: correction.inputComment,
            rcptAnno_annotationID: annotation.annotationId,
            rcptAnnoUPT: rcptCorrection.rcptAnnoUPT,
            rcptAnnoAnnotation: JSON.stringify(annotation),
          },
          {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
        )
        .subscribe((result: any) => {
          this.responseHandler.edit(
            result,
            annotation,
            this.VCPdfViewer,
            this.receiptCorrectionTable
          );
          this.workspace.isLoading = false;
          this.VCCorrection.initialize();
          this.visibilityController.setDefault();
          this.workspace.reviewPreCalc.preCalc();
        });
    } else {
      this.VCCorrection.correction = this.VCCorrection.valuesClone;
      this.VCCorrection.initialize();
      this.visibilityController.setDefault();
    }
  }

  // Input: Table-Row
  deleteCorrection(changeByPDFViewer = false): void {
    const correction = this.receiptCorrectionTable.selectedRow;
    const annotation = this.receiptPDFViewer.focusAnnotation;

    if (correction && this.securityHandler.canEdit()) {
      this.workspace.isLoading = true;
      this.excRest
        .delete(
          this.excRest.computeUrl('ReceiptCorrectionD', {
            rcptID: this.Data.rcptID,
            annotationID: correction[this.receiptCorrectionTable.selectKey],
          }),
          {rcptAnnoUPT: correction.rcptAnnoUPT},
          {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
        )
        .subscribe((result: any) => {
          this.responseHandler.delete(
            result,
            annotation,
            this.VCPdfViewer.VCSyncfusionPdfViewer,
            this.receiptCorrectionTable,
            changeByPDFViewer
          );
          this.VCreceiptCorrectionTable.selectedRow = -1;
          this.receiptCorrectionTable.preSelectedIndex = -1;
          this.workspace.isLoading = false;
          this.receiptPDFViewer.focusAnnotation = undefined;
          this.workspace.reviewPreCalc.preCalc();
          this.visibilityController.setDefault();
          this.saveAnnotatedFile();
        });
    }
  }

  receiptNote(cancelToken?: boolean): void {
    if (
      this.securityHandler.canEdit() &&
      !this.workspace.isLoading &&
      !this.workspace.isLoadingPreview
    ) {
      if (!cancelToken) {
        if (this.receiptPDFViewer.annotationAddMode.mode !== 'None') {
          // console.log('receiptNote - create');
          this.createReceiptNote(cancelToken);
        } else if (this.VCreceiptNoteTable.selectedRow !== -1) {
          // console.log('receiptNote - edit');
          this.editReceiptNote(cancelToken);
        }
      } else if (!this.visibilityController.note) {
        this.visibilityController.noteSwitch();
      }
    }
  }

  formatTextAnnotation(Values: any): string {
    return `${Values.rcptNtsRefText ? `Bezug: ${Values.rcptNtsRefText}` : ''}${
      Values.rcptNtsNote
    }`;
  }

  // Input: PDF-Viewer-Annotation
  createReceiptNote(cancelToken?: boolean): void {
    if (this.securityHandler.canEdit()) {
      const TextAnnotation = this.VCNote.getValues();
      const annotation = this.receiptPDFViewer.focusAnnotation;

      if (!cancelToken) {
        if (
          ExcCoreModule.Array.ExistsObject(
            this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
            'annotationId',
            annotation.annotationId
          )
        ) {
          Object.assign(annotation, {
            bodyValue: this.formatTextAnnotation(TextAnnotation),
          });

          this.excRest
            .post(
              this.excRest.computeUrl('ReceiptNoteC', {
                rcptID: this.Data.rcptID,
              }),
              {
                rcptNtsNote: TextAnnotation.rcptNtsNote,
                rcptNtsReferenceText: TextAnnotation.rcptNtsRefText ? '' : '',
                rcptAnno_annotationID: annotation.annotationId,
                rcptAnnoAnnotation: JSON.stringify(annotation),
              },
              {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
            )
            .subscribe((result: any) => {
              this.responseHandler.create(
                result,
                annotation,
                this.VCPdfViewer,
                this.receiptNoteTable
              );

              if (this.receiptPDFViewer.annotationAddMode.mode === 'FreeText') {
                this.VCPdfViewer.viewer.annotation.setAnnotationMode('None');
              }
            });
        }
      }
    }
  }

  // Input: Table-Row
  editReceiptNote(cancelToken?: boolean): void {
    const rcptNote = this.receiptNoteTable.data[this.VCreceiptNoteTable.selectedRow];
    const TextAnnotation = this.VCNote.getValues();

    this.receiptPDFViewer.focusAnnotation = ExcCoreModule.Array.GetObject(
      this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
      'annotationId',
      rcptNote.rcptAnno_annotationID
    );

    const annotation = this.editFocusAnnotation(TextAnnotation.rcptNtsNote);

    if (!cancelToken) {
      this.workspace.isLoading = true;
      Object.assign(annotation, {
        bodyValue: this.formatTextAnnotation(TextAnnotation),
      });

      this.excRest
        .put(
          this.excRest.computeUrl('ReceiptNoteU', {
            rcptID: this.Data.rcptID,
            annotationID: annotation.annotationId,
          }),
          {
            rcptNtsNote: TextAnnotation.rcptNtsNote,
            rcptAnnoUPT: rcptNote.rcptAnnoUPT,
            rcptAnnoAnnotation: JSON.stringify(annotation),
          },
          {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
        )
        .subscribe((result: any) => {
          this.responseHandler.edit(
            result,
            annotation,
            this.VCPdfViewer,
            this.receiptNoteTable
          );
          this.receiptPDFViewer.focusAnnotation = undefined;
          this.workspace.isLoading = false;
          this.VCNote.initialize();
          this.visibilityController.setDefault();
        });
    } else {
      this.VCNote.note = this.VCNote.valuesClone;
      this.VCNote.initialize();
      this.visibilityController.setDefault();
    }
  }

  // Input: Table-Row
  deleteNote(changeByPDFViewer = false): void {
    const note = this.receiptNoteTable.selectedRow;
    const annotation = this.receiptPDFViewer.focusAnnotation;

    if (note && this.securityHandler.canEdit()) {
      this.workspace.isLoading = true;
      this.excRest
        .delete(
          this.excRest.computeUrl('ReceiptNoteD', {
            rcptID: this.Data.rcptID,
            annotationID: note[this.receiptNoteTable.selectKey],
          }),
          {rcptAnnoUPT: note.rcptAnnoUPT},
          {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
        )
        .subscribe((result: any) => {
          this.responseHandler.delete(
            result,
            annotation,
            this.VCPdfViewer.VCSyncfusionPdfViewer,
            this.receiptNoteTable,
            changeByPDFViewer
          );
          this.VCreceiptNoteTable.selectedRow = -1;
          this.receiptNoteTable.preSelectedIndex = -1;
          this.workspace.isLoading = false;
          this.receiptPDFViewer.focusAnnotation = undefined;
          this.visibilityController.setDefault();
          this.saveAnnotatedFile();
        });
    }
  }

  // </Receipt>

  /**
   * <Receipt State>
   */
  showMessageSureAbout = (tabinstanceCloseable?: boolean): boolean => {
    if (!this.checkChanges) {
      this.checkChanges = true;
      return true;
    }

    if (
      (this.VCreceipt && this.VCreceipt?.rcptChanged && this.VCreceipt?.receiptEditMode) ||
      (this.VCreceiptReview && this.VCreceiptReview?.reviewChanged && this.VCreceiptReview?.reviewEditMode)
    ) {
      this.modalService
        .showSimple(
          this.getGlobal('Attention') + '!',
          this.getResource('UnsavedChanges'),
          true,
          true,
          this.getGlobal('Save'),
          this.getGlobal('Reject')
        )
        .subscribe((ret: boolean) => {
          this.checkChanges = false;
          this.checkReviewChanges = false;

          if (this.VCreceipt.receiptEditMode) {
            this.saveReceipt(!ret);
          } else if (this.VCreceiptReview && this.VCreceiptReview.reviewEditMode) {
            this.receiptReviewSave(!ret);
          }
          if (this.tabinstance && tabinstanceCloseable) {
            this.reloadOpenerView.emit(); // reloadData
            this.tabinstance.Close();
          }
        });

      return false;
    } else {
      this.checkChanges = false;
      if (this.VCreceipt.receiptEditMode) {
        this.VCreceipt.receiptEditMode = false;
      }
      if (this.VCreceiptReview && this.VCreceiptReview.reviewEditMode) {
        this.VCreceiptReview.reviewEditMode = false;
      }
      return true;
    }
  }

  pickReceiptReview = (): void => {
    if (this.securityHandler.canPick()) {
      this.modalService
        .showSimple(
          this.getRessource('Review'),
          this.getRessource('PickRcptText'),
          true,
          true,
          this.getRessource('PickRcptConfirm'),
          this.getRessource('PickRcptReject')
        )
        .subscribe((ret: boolean) => {
          if (ret) {
            this.pickReview();
          }
        });
    }
  }

  pickReview(): void {
    if (this.securityHandler.canPick()) {
      this.excCall_RcptChangeState();
      this.showMessageSomething(
        'Belegstatus NEU: ' +
        this.enumSvc.getEnumerationText(
          'ReceiptStatus',
          this.workspace.receiptData.rcpt_enmIdent_ReceiptStatus
        ),
        'fal fa-clipboard-list-check',
        'md-toast bg-green'
      );
    }
  }

  excCall_RcptChangeState(): void {
    if (this.securityHandler.powerUser()) {
      this.excRest
        .put(
          this.excRest.computeUrl('ReceiptU_Review', {
            rcptID: this.Data.rcptID,
          }),
          {
            rcptUPT: this.workspace.receiptData.rcptUPT,
            rcptAccepted: null,
            rcptStateChange: true,
            rcptReviewDate: null,
            rcptReviewComment: null,
            rcptReviewReasons: null,
            rcptCommentNext: null,
          },
          {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
        )
        .subscribe((result: any) => {
          if (result) {
            this.showMessageSureAbout(false);

            this.workspace.loadData(result.data.Receipt);
            this.VCreceipt.initialize();
            this.VCreceiptReview.initialize();
            this.workspace.isLoading = false;
          }
        });
    }
  }

  receiptFinishRV(): void {
    if (this.securityHandler.canEdit()) {

      this.modalService
        .showSimple(
          this.getRessource('FinishRV.Header'),
          this.getResource('FinishRV.Text'),
          true,
          true,
          this.getRessource('FinishRV.Save'),
          this.getGlobal('Cancel')
        ).subscribe((rtVal: any) => {
          if (rtVal) {
            this.workspace.isLoading = true;
            this.excRest
              .put(
                this.excRest.computeUrl('ReceiptU_FinishRV', {
                  rcptID: this.Data.rcptID,
                }),
                {
                  rcptUPT: this.workspace.receiptData.rcptUPT,
                },
                {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
              )
              .subscribe((result: any) => {
                if (result && result.success) {
                  this.loadCheckviewData();
                  this.VCreceiptReview.initialize();

                  this.VCPdfViewer.viewer.reload();
                  this.VCPdfViewer.enableAnnotationTools(false);
                }
              });
          }
      });
    }
  }

  async receiptReviewSave(
    cancelToken = false,
    stateChange?: boolean,
    accepted?: boolean
  ): Promise<void> {
    if (!cancelToken && this.securityHandler.canEdit()) {
      if (
        (this.VCreceiptReview.reviewClone || this.VCreceiptReview?.reviewChanged)
        && !this.workspace.isLoading
      ) {
        this.workspace.isLoading = true;
        const review = this.VCreceiptReview.reviewClone;

        await new Promise<void>((resolve, reject) => {
          this.excRest
            .put(
              this.excRest.computeUrl('ReceiptU_Review', {
                rcptID: this.Data.rcptID,
              }),
              {
                rcptUPT: this.workspace.receiptData.rcptUPT,
                rcptAccepted: accepted,
                rcptStateChange: stateChange,
                rcptReviewDate: review.rcptReviewDate,
                rcptReviewComment: review.rcptReviewComment,
                rcptReviewReasons: review.rcptReviewReasons,
                rcptReviewHints: review.rcptReviewHints,
                rcptCommentNext: review.rcptCommentNext,
                rcptPosTable: review.rcptPosTable,
                rcptSumTable: review.rcptSumTable,
              },
              { MetaInfo: { dataPaging: { pageNo: 0, pageSize: 0 } } }
            )
            .subscribe({
              next: (result: any) => {
                if (result) {
                  this.workspace.loadData(result.data.Receipt);
                  this.VCreceiptReview.initialize();
                  this.loadCommentaryList();
                }
                this.workspace.isLoading = false;
                this.VCreceiptReview.reviewEditMode = false;
                resolve();
              },
              error: (err) => {
                this.workspace.isLoading = false;
                this.VCreceiptReview.reviewEditMode = false;
                reject(err);
              },
            });
        });
      }
    } else {
      this.VCreceiptReview.initialize();
      this.workspace.isLoading = false;
      this.VCreceiptReview.reviewEditMode = false;
    }
  }

  receiptReview(
    btnText: string,
    stateChange?: boolean,
    accepted?: boolean
  ): void {
    if (  this.VCreceiptReview.conditions.canChangeState()
      && (btnText === this.getRessource('review.proofIt') && stateChange && accepted === undefined)) {
      return;
    }
    this.modalService
      .show('ReceiptCommentNextComponent', {
        modalHeader: this.getRessource('review.changeStateTitle', {btnText}),
        changeStateText: this.getRessource(
          `review.changeStateText.${
            this.workspace.receiptData.rcpt_enmIdent_ReceiptStatus <= 2
              ? 'beforeProof'
              : accepted !== undefined
                ? 'beforeFinish'
                : 'beforeToSv'
          }`,
          {btnText}
        ),
        btnText,
        reviewClone: this.VCreceiptReview.reviewClone,
        forceComment:
          this.workspace.receiptData.rcpt_enmIdent_ReceiptStatus === 4 &&
          stateChange &&
          accepted === undefined,
      })
      .subscribe(async (ret: boolean) => {
        if (ret) {
          await this.receiptReviewSave(false, stateChange, accepted);

          if (stateChange) {
            this.showMessageSomething(
              'Belegstatus NEU: ' +
              this.enumSvc.getEnumerationText(
                'ReceiptStatus',
                this.workspace.receiptData.rcpt_enmIdent_ReceiptStatus
              ),
              'fal fa-clipboard-list-check',
              'md-toast bg-green'
            );
            if (accepted !== undefined) {
              if (accepted) {
                this.showMessageSomething(
                  'Beleg freigegeben',
                  'fal fa-clipboard-list-check',
                  'md-toast bg-green'
                );
              } else if (!accepted) {
                this.showMessageSomething(
                  'Beleg stoniert',
                  'fal fa-file-minus',
                  'md-toast bg-red'
                );
              }
            }
            if (this.securityHandler.canPick()) {
              this.pickReceiptReview();
            }
            this.workspace.isLoading = false;
          } else {
            this.showMessageSomething(
              'Bearbeitung gespeichert',
              'fal fa-clipboard-list',
              'md-toast'
            );
          }
          this.workspace.isLoading = false;
        } else {
          this.VCreceiptReview.initialize();
          this.showMessageSomething(
            'Bearbeitung fortgesetzt',
            'fal fa-clipboard-list',
            'md-toast'
          );
          this.workspace.isLoading = false;
        }
      });
  }

  receiptReviewU_RevokeState(btnText: string): void {
    this.modalService
      .show('ReceiptCommentNextComponent', {
        modalHeader: this.getRessource('review.changeStateTitle', {btnText}),
        changeStateText: this.getRessource(
          `review.changeStateText.${
            this.isOneOf(this.workspace.receiptData.rcpt_enmIdent_ReceiptStatus, [10, 20]) ?
              'revokeFinal' : 'revokeFinal'
          }`,
          {btnText}
        ),
        btnText,
        reviewClone: this.VCreceiptReview.reviewClone,
        forceComment: true,
      })
      .subscribe((ret: boolean) => {
        if (ret) {
          const review = this.VCreceiptReview.reviewClone;
          this.excRest
            .put(this.excRest.computeUrl('ReceiptU_RevokeState', {
              rcptID: this.Data.rcptID,
            }), {
              rcptUPT: this.workspace.receiptData.rcptUPT
              , rcptCommentNext: review.rcptCommentNext,
            }, {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}})
            .subscribe((result: any) => {
              if (result) {
                this.workspace.loadData(result.data.Receipt);
                this.VCreceiptReview.initialize();
                this.loadCommentaryList();
              }
              this.workspace.isLoading = false;
            });
        }
      });
  }

  // </Receipt State>

  // <Receipt Reference>
  OpenReferenceTab(): void {
    if (this.workspace.details.caseDetails?.auID) {
      const tab = new ExgApplicationTab(
        'Referenzen: ' + this.workspace.details.caseDetails?.auNr,
        ViewerComponent,
        {caseID: this.workspace.details.caseDetails?.auID},
        this.workspace.details.caseDetails?.auID
      );
      tab.Open();
    }
  }
  // </Receipt Reference>

  receiptOpenMessageModal = (): void => {
    if (this.securityHandler.canView()) {
      this.modalService
        .show('CommentaryModalComponent', {
          checkview: this,
        })
        .subscribe(() => {
          this.loadCommentaryList();
        });
    }
  }

  loadCommentaryList = (): void => {
    if (this.securityHandler.canView()) {
      this.excRest
        .get(
          this.excRest.computeUrl('ReceiptCommentary', {
            rcptID: this.Data.rcptID,
          }),
          {}
        )
        .subscribe((response: any) => {
          if (response && response.success) {
            this.workspace.loadCommentaries(
              response.data.Commentary,
              response.data.CommentaryDate
            );
          }
        });
    }
  }

  commentaryCreate = (obj: { commText: string; commTyp: number }): void => {
    if (this.securityHandler.canView()) {
      this.excRest
        .post(
          this.excRest.computeUrl('ReceiptCommentary', {
            rcptID: this.Data.rcptID,
          }),
          obj
        )
        .subscribe((response: any) => {
          if (response && response.sucess) {
            this.workspace.loadCommentaries(
              response.data.Commentary,
              response.data.CommentaryDate
            );
            this.loadCommentaryList();
          }
        });
    }
  }

  // <ReceiptCompany>
  receiptChooseCompany(rcptLink: false): void {
    if (this.securityHandler.canEdit()) {
      this.modalService
        .show('ReceiptCompanyListComponent', {
          rcptLink,
          checkviewFunction: (obj: any) => {
            this.companyRListFillObject(obj);
          },
        })
        .subscribe((result: any) => {
          if (!rcptLink || result.compDoDel) {
            if (result && (result.compToRcpt || result.compDoDel)) {
              this.receiptCompany(result);
            }
          } else {
            if (result && (result.compLinkRcpt)) {
              this.receiptCompanyLinkCU(result.compID);
            }
          }
        });
    }
  }

  companyRListFillObject = (dataTableObj: any) => {
    dataTableObj.isLoading = true;
    dataTableObj.state = 1;
    this.excRest
      .get(
        this.excRest.computeUrl('CompanyR_List', {
          fts: dataTableObj.searchValue,
        }),
        {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
      )
      .subscribe((result: any) => {
        dataTableObj.loadData(result.data, result.paging);
      });
  }

  companyRFillObject = () => {
    this.workspace.isLoading = true;
    if (this.VCreceipt.VCcompanyForm.CompanyDataClone.compID) {
      this.excRest
        .get(
          this.excRest.computeUrl('CompanyGROOT', {
            compID: this.VCreceipt.VCcompanyForm.CompanyDataClone.compID,
          }),
          {
            MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}},
          }
        )
        .subscribe((result: any) => {
          if (result && result.success) {
            this.workspace.loadCompanyData(
              result.data.Company ? result.data.Company : {}
            );
          }
          this.workspace.isLoading = false;
          this.VCreceipt.receiptCompanyInit(
            this.VCreceipt.visibilityController.companyForm
          );
          this.chDecRef.markForCheck();
        });
    } else {
      this.workspace.isLoading = false;
      this.chDecRef.markForCheck();
    }
  }

  receiptCompany = (company: any, link = false): void => {
    if (this.securityHandler.canEdit()) {
      if (!company?.compID) {
        this.receiptCompanyC(company, link);
      } else {
        if (company.compToRcpt) {
          this.receiptCompanyU(company.compID, company.compUPT);
        } else {
          if (!company.compDoDel) {
            this.CompanyU(company, link);
          } else if (company.compDoDel) {
            this.CompanyD(company.compID, company.compUPT);
          }
        }
      }
    }
  }

  receiptCompanyC(values: any, link = false): void {
    this.excRest
      .post(
        this.excRest.computeUrl('ReceiptCompanyCU', {
          rcptID: this.Data.rcptID,
        }),
        {
          rcptUPT: this.workspace.receiptData.rcptUPT,
          compName: values.compName,
          compAdressline1: values.compAdressline1,
          compAdressline2: values.compAdressline2,
          compAdressline3: values.compAdressline3,
          compAdressline4: values.compAdressline4,
          compZip: values.compZip,
          compLocation: values.compLocation,
          compCountry: values.compCountry,
          compContactNumber: values.compContactNumber,
          compContactMail: values.compContactMail,
          compWebsite: values.compWebsite,
          compTaxID: values.compTaxID,
          compSalesTaxID: values.compSalesTaxID,
          compRegisterNo: values.compRegisterNo,
          link
        },
        {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
      )
      .subscribe((result: any) => {
        console.log('receiptCompanyC');
        if (result && result.success) {
          if (!link) {
            this.workspace.loadCompanyData(result.data.Company);
          }
          this.workspace.loadCompanyLinkData(result.data.CompanyLink);
          this.showMessageSomething(
            'Aussteller erstellt',
            'fal fa-building',
            'md-toast bg-green'
          );
        }
        this.VCreceipt.receiptCompanyInit(
          this.VCreceipt.visibilityController.companyForm
        );
        this.chDecRef.markForCheck();
      });
  }

  receiptCompanyU(compID: any, compUPT: any, link = false): void {
    if (compID && compUPT) {
      this.excRest
        .put(
          this.excRest.computeUrl('ReceiptCompanyU', {
            rcptID: this.Data.rcptID,
            compID,
          }),
          {
            rcptUPT: this.workspace.receiptData.rcptUPT,
            compUPT,
          }
        )
        .subscribe((result: any) => {
          if (result && result.success) {
            if (result.data.Receipt && this.workspace.receiptData) {
              this.workspace.receiptData.rcptUPT = result.data.Receipt.rcptUPT;
            }
            if (!link) {
              this.workspace.loadCompanyData(result.data.Company);
            }
            this.workspace.loadCompanyLinkData(result.data.CompanyLink);
            this.showMessageSomething(
              'Aussteller zugeordnet',
              'fal fa-building',
              'md-toast bg-green'
            );
          }
          this.VCreceipt.receiptCompanyInit(
            this.VCreceipt.visibilityController.companyForm
          );
          this.chDecRef.markForCheck();
        });
    }
  }

  CompanyU(values: any, link = false): void {
    this.excRest
      .put(
        this.excRest.computeUrl('CompanyGROOT', {
          compID: values?.compID,
        }),
        {
          rcptID: this.Data.rcptID,
          rcptUPT: this.workspace.receiptData.rcptUPT,
          compUPT: values?.compUPT,
          compName: values?.compName,
          compAdressline1: values?.compAdressline1,
          compAdressline2: values?.compAdressline2,
          compAdressline3: values?.compAdressline3,
          compAdressline4: values?.compAdressline4,
          compZip: values?.compZip,
          compLocation: values?.compLocation,
          compCountry: values?.compCountry,
          compContactNumber: values?.compContactNumber,
          compContactMail: values?.compContactMail,
          compWebsite: values?.compWebsite,
          compTaxID: values?.compTaxID,
          compSalesTaxID: values?.compSalesTaxID,
          compRegisterNo: values?.compRegisterNo,
        },
        {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
      )
      .subscribe((result: any) => {
        console.log('CompanyU');
        console.log('aisupl prev' , this.aiSupplementMode , 'q' + this.aiSupplementPrevCompany);
        this.aiSupplementMode = false;
        this.aiSupplementPrevCompany = null;
        if (result && result.success) {
          if (!link) {
            this.workspace.loadCompanyData(result.data.Company);
          }
          this.workspace.loadCompanyLinkData(result.data.CompanyLink);
          this.showMessageSomething(
            'Aussteller aktualisiert',
            'fal fa-building',
            'md-toast bg-green'
          );
          this.VCreceipt.receiptCompanyInit(
            this.VCreceipt.visibilityController.companyForm
          );
        }
        this.VCreceipt.receiptCompanyInit();
        this.chDecRef.markForCheck();
      });
  }

  CompanyD(compID: any, compUPT: any): void {
    if (compID && compUPT) {
      this.excRest
        .delete(
          this.excRest.computeUrl('CompanyGROOT', {
            compID,
          }),
          {
            compUPT,
          }
        )
        .subscribe((result: any) => {
          if (result.success) {
            this.workspace.loadCompanyData(result.data.Company);
            this.workspace.duplicates = [];
            this.showMessageSomething(
              'Aussteller gelöscht',
              'fal fa-delete',
              'md-toast bg-red'
            );
          }
        });
    }
  }

  receiptUnlinkCompany(compID: any): void {
    if (compID) {
      this.excRest
        .delete(
          this.excRest.computeUrl('ReceiptCompanyCU', {
            rcptID: this.Data.rcptID,
          }),
          {
            rcptUPT: this.workspace.receiptData.rcptUPT,
          }
        )
        .subscribe((result: any) => {
          if (result.success) {
            this.workspace.loadCompanyData(result.data.Company);
            this.showMessageSomething(
              'Zuordnung entfernt',
              'fal fa-delete',
              'md-toast bg-red'
            );
          }
          this.VCreceipt.receiptCompanyInit(
            this.VCreceipt.visibilityController.companyForm
          );
        });
    }
  }

  receiptCompanyLinkCU(compID: any): void {
    if (compID) {
      this.excRest
        .put(
          this.excRest.computeUrl('ReceiptCompanyLinkCUD', {
            rcptID: this.Data.rcptID,
            compID,
          }), {}
        )
        .subscribe((result: any) => {
          if (result && result.success) {
            this.workspace.loadCompanyLinkData(result.data.CompanyLink);
            this.showMessageSomething(
              'Sub-Aussteller zugeordnet',
              'fal fa-building',
              'md-toast bg-green'
            );
            this.VCreceipt.receiptCompanyInit(
              this.VCreceipt.visibilityController.companyForm
            );
          }
          this.chDecRef.markForCheck();
        });
    }
  }

  // wird in ReceiptDetails verwendet
  receiptCompanyLinkD(compID: any): void {
    if (compID) {
      this.excRest
        .delete(
          this.excRest.computeUrl('ReceiptCompanyLinkCUD', {
            rcptID: this.Data.rcptID,
            compID,
          }), {}
        )
        .subscribe((result: any) => {
          if (result && result.success) {
            this.workspace.loadCompanyLinkData(result.data.CompanyLink);
            this.showMessageSomething(
              'Zuordnung entfernt',
              'fal fa-delete',
              'md-toast bg-red'
            );
            this.VCreceipt.receiptCompanyInit(
              this.VCreceipt.visibilityController.companyForm
            );
          }
          this.chDecRef.markForCheck();
        });
    }
  }

  // </     >
  openWorkspace(): void {
    if (this.workspace.details.taskDetails?.vorgID) {
      this.appSvc.Task.Workspace.OpenTabV2(
        this.workspace.details.taskDetails?.vorgID
      );
    }
  }

  showMessageSomething(
    msg: string,
    icon: string,
    additionalClasses?: string | ''
  ): void {
    this.modalService.showToast(msg, `md-toast ${additionalClasses}`, icon);
  }

  finish(before?: boolean): void {
    if (this.showMessageSureAbout()) {
      this.reloadOpenerView.emit(); // reloadData
      if (!before) {
        this.tabinstance.Close();
      }
    }
  }

  receiptShowPreviewModal(): void {
    if (!this.workspace.isLoadingPreview) {
      this.modalService.show('ModalPdfViewerComponent', {rcptID: this.Data.rcptID, endpoint: 'ReceiptR_Review'})
        .subscribe(() => {
        });
    }
  }

  receiptCaseOpenTestReport(): void {
    if (!this.workspace.isLoading && !this.workspace.isLoadingPreview) {
      this.workspace.isLoadingPreview = true;
      this.visibilityController.caseReportxlsx = false;

      this.excRest
        .get(
          this.excRest.computeUrl('Case_Report_fileType', {
            auID: this.workspace.details.caseDetails.auID,
            fileType: 'xlsx'
          }),
          {export: true}
        )
        .subscribe(() => {
          this.workspace.isLoadingPreview = false;
          this.visibilityController.caseReportxlsx = true;
          this.chDecRef.markForCheck();
        });
    }
  }

  receiptCaseOpenTestReportPdf(): void {
    if (!this.workspace.isLoading && !this.workspace.isLoadingPreview) {
      this.OpenReportParamsModal()
        .subscribe((reportParams: any) => {
          if (reportParams) {
            this.workspace.isLoadingPreview = true;
            this.visibilityController.caseReportpdf = false;

            this.excRest
              .get(
                this.excRest.computeUrl('Case_Report_fileTypeEx', {
                  auID: this.workspace.details.caseDetails.auID,
                  fileType: 'pdf',
                  extensions:
                    !reportParams.withReceipts && !reportParams.withReviews ? 0 :
                      reportParams.withReviews && !reportParams.withReceipts ? 2 :
                        reportParams.withReceipts && !reportParams.withReviews ? 1 : 3
                }),
                {export: true}
              )
              .subscribe(() => {
                this.workspace.isLoadingPreview = false;
                this.visibilityController.caseReportpdf = true;
                this.chDecRef.markForCheck();
              });
          }
        });
    }
  }

  receiptTaskOpenTestReport(): void {
    if (!this.workspace.isLoading && !this.workspace.isLoadingPreview) {
      this.workspace.isLoadingPreview = true;
      this.visibilityController.taskReportxlsx = false;

      this.excRest
        .get(
          this.excRest.computeUrl('Task_Report_fileType', {
            vorgID: this.workspace.details.taskDetails.vorgID,
            fileType: 'xlsx'
          }),
          {export: true}
        )
        .subscribe(() => {
          this.workspace.isLoadingPreview = false;
          this.visibilityController.taskReportxlsx = true;
          this.chDecRef.markForCheck();
        });
    }
  }

  receiptTaskOpenTestReportPdf(): void {
    if (!this.workspace.isLoading && !this.workspace.isLoadingPreview) {
      this.OpenReportParamsModal()
        .subscribe((reportParams: any) => {
          if (reportParams) {
            this.workspace.isLoadingPreview = true;
            this.visibilityController.taskReportpdf = false;

            this.excRest
              .get(
                this.excRest.computeUrl('Task_Report_fileTypeEx', {
                  vorgID: this.workspace.details.taskDetails.vorgID,
                  fileType: 'pdf',
                  extensions:
                    !reportParams.withReceipts && !reportParams.withReviews ? 0 :
                      reportParams.withReviews && !reportParams.withReceipts ? 2 :
                        reportParams.withReceipts && !reportParams.withReviews ? 1 : 3
                }),
                {export: true}
              )
              .subscribe(() => {
                this.workspace.isLoadingPreview = false;
                this.visibilityController.taskReportpdf = true;
                this.chDecRef.markForCheck();
              });
          }
        });
    }
  }

  OpenReportParamsModal(): any {
    if (!this.workspace.isLoading
      && !this.workspace.isLoadingPreview
    ) {
      return this.modalService.show('ReceiptReportComponent', {});
    }
  }

  OpenFileReplaceModal(): void {
    if (!this.workspace.isLoading
      && !this.workspace.isLoadingPreview
      && this.securityHandler.canEdit()
      && !this.aiJobRunning()
    ) {
      this.appSvc.Receipt.Upload.OpenModalCU_File(
        this.Data.rcptID,
        {
          onlyNotes: true,
          rcpt_fileStreamID: this.workspace.receiptData.rcpt_fileStreamID,
          vorgID: this.workspace.details.taskDetails?.vorgID
        },
        {Events: this.Events}
      );
    }
  }

  OpenFileAddModal(): void {
    if (!this.workspace.isLoading
      && !this.workspace.isLoadingPreview
      && this.securityHandler.canEdit()
      && !this.aiJobRunning()
    ) {
      this.appSvc.Receipt.Upload.OpenModalU_AddFile(
        this.Data.rcptID,
        {
          onlyNotes: true,
          rcpt_fileStreamID: this.workspace.receiptData.rcpt_fileStreamID,
          vorgID: this.workspace.details.taskDetails?.vorgID
        },
        {Events: this.Events}
      );
    }
  }

  addOpenSumPosition(): void {
    if (this.openSum > 0) {
      this.modalService.showSimple(
        'Differenzbetrag freigeben',
        `Betrag von ${this.openSum} € freigeben?`,
        true,
        true,
        'Freigeben',
        this.getGlobal('Cancel')
      ).subscribe((retValue: any) => {
        if (retValue) {
          this.openSumMode = true;
          this.VCPdfViewer.viewer.annotation.addCustomStamp(10, 10, 'blank');
          this.showMessageSomething(
            'Differenzbetrag freigeben',
            'fal fa-check',
            'md-toast bg-green'
          );
        }
      });
    }
  }

  addDeclineOpenSumPosition(): void {
    if (this.openSum > 0) {
      this.modalService.showSimple(
        'Differenzbetrag ablehnen',
        `Betrag von ${this.openSum} € ablehnen?`,
        true,
        true,
        'Ablehnen',
        this.getGlobal('Cancel')
      ).subscribe((retValue: any) => {
        if (retValue) {
          this.openDeclineSumMode = true;
          this.VCPdfViewer.viewer.annotation.addCustomStamp(10, 10, 'blank');
          this.showMessageSomething(
            'Restbetrag abgelehnt',
            'fal fa-xmark',
            'md-toast bg-red'
          );
        }
      });
    }
  }

  checkDuplicates(showModal = false): void {
    if (
      this.excSecurity.isFeatured('RECEIPTCHECKDUPL')
      && this.workspace.receiptData.rcptNumber && this.workspace.receiptData.rcptNumber.length > 0
      && this.workspace.receiptData.rcpt_enmIdent_ReceiptType
      && this.workspace.receiptData.rcpt_compID
    ) {
      this.excRest
        .get(
          this.excRest.computeUrl('ReceiptR_Duplicates', {
            rcptID: this.workspace.receiptData.rcptID,
            rcptNumber: this.workspace.receiptData.rcptNumber,
            rcpt_enmIdent_ReceiptType: this.workspace.receiptData.rcpt_enmIdent_ReceiptType,
            rcpt_compID: this.workspace.receiptData.rcpt_compID
          }),
          {}
        )
        .subscribe((res: any) => {
          if (res && res.success && res.data) {
            if (res.data.Receipt) {
              this.workspace.duplicates = res.data.Receipt;
              if (showModal) {
                this.showModalReceiptCheckDuplicate();
              }
            }
          }
        });
    }
  }

  showModalReceiptCheckDuplicate(): void {
    if (this.workspace.duplicates.length > 0) {
      this.modalService
        .show('ReceiptDuplicatesCheckComponent', {
          ReceiptDuplicates: this.workspace.duplicates
          , canDelete: this.workspace.receiptData.rcptState <= 2 || this.excSecurity.isFeatured('RECEIPTDELETE')
        }).subscribe((result: any) => {
          if (result && result.del) {
            this.deleteReceipt();
          }
        });
    }
  }

  deleteReceipt(): void {
    if (this.workspace.receiptData.rcptState <= 2 || this.excSecurity.isFeatured('RECEIPTDELETE')) {
      this.excRest
        .delete(
          this.excRest.computeUrl('ReceiptD'
            , {rcptID: this.workspace.receiptData.rcptID}
          ), {rcptUPT: this.workspace.receiptData.rcptUPT}
        ).subscribe(
          (ret: any) => {
            if (ret && ret.success) {
              this.modalService
                .showToast(
                  ret.success
                    ? `${this.getGlobal('Success')} ${this.getGlobal('Delete')}`
                    : this.getGlobal('Cancel')
                  , `md-toast ${ret.success ? 'bg-green' : 'bg-red'}`
                  , ret.success ? 'fal fa-trash-can-check' : 'fal fa-times-circle');
              this.Events?.Receipt?.List?.Deleted?.emit({success: ret});
              if (this.tabinstance) {
                this.tabinstance.Close();
              }
            }
          }
        );
    }
  }

  get getCommentaryLength(): number {
    return this.workspace.commentary.filter((entry: any) => entry.commType === 1).length;
  }

  isOneOf(x: number, values: number[]): boolean {
    return values.includes(x);
  }

  aiPayload(): any {
    const r = this.workspace.aiResult;
    if (r && r.airPayload) {
      return JSON.parse(r.airPayload);
    }
    return null;
  }

  aiProcessingComment(): string {
    const p = this.aiPayload();
    return p && p.receipt && p.receipt.processingComment ? p.receipt.processingComment : '';
  }
}
